import { ApplicationState } from '@mews-commander/types';
import { createAction } from '@mews/framework';
import { createOptionsSelector } from '@mews-commander/utils';
import { Department } from '../actions/departments';
import parentSelector from '../selector';
import { createScopedBaseEntitySelectors, createScopedEntitiesReducer } from './utils';

export const NAME = 'departments';
export const DEPARTMENTS_LOADED = 'DEPARTMENTS_LOADED';

export const [getDepartments] = createScopedBaseEntitySelectors<
    ApplicationState,
    Department,
    typeof NAME,
    'enterpriseId'
>(parentSelector, NAME, 'enterpriseId');

export const departmentsReducer = createScopedEntitiesReducer({
    ADD_SUCCESS: DEPARTMENTS_LOADED,
});

export const getDepartmentOptions = createOptionsSelector(getDepartments, { value: 'id', label: 'name' });

export const setDepartments = (departments: Department[], enterpriseId: string) =>
    createAction(DEPARTMENTS_LOADED, departments, { scope: enterpriseId });
